import { Link } from 'react-router-dom';
import Kicker from '../components/Kicker';

function StoryCards({ aircraftEntries = [], regionEntries = [] }) {
  const cards = [];
  const topAircraft = aircraftEntries[0];
  if (topAircraft) {
    cards.push({
      title: `${topAircraft.operator || topAircraft.registration || topAircraft.icao24} logged ${topAircraft.eventCount} hovers this week`,
      sub: `${topAircraft.hoverTimeLabel || ''}${topAircraft.hoverTimeLabel ? ' total · ' : ''}${topAircraft.regionName || topAircraft.topGeohash5 || ''}`,
      href: `/a/${topAircraft.icao24}`,
    });
  }
  const topRegion = regionEntries[0];
  if (topRegion) {
    cards.push({
      title: `A long week for ${topRegion.regionName || topRegion.geohash5}`,
      sub: `${topRegion.eventCount} hovers${topRegion.hoverTimeLabel ? ` · ${topRegion.hoverTimeLabel} total` : ''}`,
      href: topRegion.slug ? `/n/${topRegion.slug}` : `/r/${topRegion.geohash5}`,
    });
  }
  if (cards.length === 0) return null;

  return (
    <section className="story-cards">
      <Kicker>READ MORE</Kicker>
      <div className="story-card-grid">
        {cards.map((c) => (
          <Link key={c.href} to={c.href} className="story-card">
            <div className="story-card-title">{c.title}</div>
            <div className="story-card-sub">{c.sub}</div>
            <div className="story-card-arrow" aria-hidden>→</div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default StoryCards;
